import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { Delegacion } from '../models/ListDelegaciones';

export default class ListaDelegacionesStore {
    ListaDelegacionesEntry = new Map<any, Delegacion>();
    selectedListaDelegaciones: Delegacion | undefined

    editMode = false;
    loading = false;
    loadingInitial = false;
    cargar = 1

    constructor() {
        makeAutoObservable(this)
    }

    get ListaDelegaciones() {        
        return Array.from(this.ListaDelegacionesEntry.values());
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    loadListaDelegaciones = async () => {
        this.loadingInitial = true;
        try {
            this.ListaDelegacionesEntry.clear()
            const lstDelegaciones: Delegacion[] = await agent.Delegaciones.list();            
            lstDelegaciones.forEach(element => {
                this.setDelega(element);
            });

            this.setLoadingInitial(false);
            return Array.from(lstDelegaciones)
        } catch (error) {
            this.setLoadingInitial(false);
            return Array.from(this.ListaDelegacionesEntry.values())
        }
    }

    private setDelega = (id: Delegacion) => {
        this.ListaDelegacionesEntry.set(id.id, id);
    }

    
   



}